import { OpenPanel } from "@openpanel/web";

const clientSecret = import.meta.env.VITE_CLIENT_SECRET;
const clientId = import.meta.env.VITE_CLIENT_ID;

export const op = new OpenPanel({
  debug: import.meta.env.DEV,

  clientSecret: clientSecret,
  clientId: clientId,

  trackOutgoingLinks: true,
  trackScreenViews: true,
  trackAttributes: true,
});
